import {
  ADD_SUB_STEP,
  DELETE_SUB_STEP,
  REPLACE_SUB_STEP,
  SET_STEP_BY_PASS,
  SET_STEPS,
  STEP_REMOVE_CHILDREN
} from "../actions/action-types";

export const stepsReducer = (state = {}, action) => {
  if (action.type === SET_STEPS) {
    return {
      ...state,
      ...action.steps
    };
  }

  let newState = { ...state };

  if (action.type === ADD_SUB_STEP) {
    const { stepIndex, subStep, subStepIndex } = action;
    if (subStepIndex === true) {
      newState[stepIndex].children.push(subStep);
    } else if (Number.isInteger(subStepIndex)) {
      newState[stepIndex].children.splice(subStepIndex + 1, 0, subStep);
    } else {
      newState[stepIndex].children = [subStep];
    }

    return newState;
  }
  if (action.type === REPLACE_SUB_STEP) {
    const { stepIndex, subStep, subStepIndex } = action;
    if (Number.isInteger(subStepIndex)) {
      newState[stepIndex].children.splice(subStepIndex + 1, 1, subStep);
    }

    return newState;
  }
  if (action.type === DELETE_SUB_STEP) {
    const { stepIndex, subStepIndex } = action;
    if (Number.isInteger(subStepIndex)) {
      newState[stepIndex].children.splice(subStepIndex, 1);
    }

    return newState;
  }
  if (action.type === SET_STEP_BY_PASS) {
    const { activeStep, byPassed } = action;

    newState[activeStep.step].children[activeStep.subStep].byPass = byPassed;

    return newState;
  }
  if (action.type === STEP_REMOVE_CHILDREN) {
    const { activeStep } = action;
    newState[activeStep.step].children = [];

    return newState;
  }

  return state;
};
